import { get } from 'hooks/use-http/useHttp'

export const fetchTodaysDate = async () => {
  const response: Date = await get(`admin/date/today`, { useApiKey: true, dieSilent: true })
  return response
}
export const getNewsByTopic = async (topic: string) => {
  const response = await get(`admin/news/${topic}`, { useApiKey: true })
  return response
}

export const useAdminApi = () => {
  return {
    fetchTodaysDate,
    getNewsByTopic
  } as const
}
